<template>
  <div class="row" v-if="!isEmpty(customForm)">
    <div class="col-lg-12">
      <div class="kt-portlet kt-portlet--height-fluid">
        <div class="kt-portlet__head kt-portlet__head--noborder">
          <div class="kt-portlet__head-label">
            <span class="kt-portlet__head-icon">
              <i class="fal fa-car"></i>
            </span>
            <h3 class="kt-portlet__head-title">Additional Data</h3>
          </div>
        </div>
        <div class="kt-portlet__body">
          <v-expansion-panels focusable flat>
            <v-expansion-panel>
              <v-expansion-panel-header> Qualitative Data </v-expansion-panel-header>
              <v-expansion-panel-content>
                <div class="kt-widget6">
                  <div class="kt-widget6__body">
                    <div
                      class="kt-widget6__item"
                      v-for="question in customForm.questions"
                      :key="question.id"
                    >
                      <span> {{ question.question }}</span>
                      <span class="blue--text kt-font-bold">
                        {{ getUserAnswer(question.answers, question.user_answer) }}
                      </span>
                    </div>
                  </div>
                </div>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  findIndex as _findIndex,
  upperCase as _upperCase,
  isEmpty as _isEmpty,
} from "lodash-es";

export default {
  name: "Qualitative Data",
  props: {
    internetShopId: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      customForm: {},
      isEmpty: _isEmpty,
    };
  },
  mounted() {
    this.axios
      .get(`v3/internet-shops/${this.internetShopId}/custom-forms`)
      .then(({ data }) => {
        this.customForm = data.data.custom_form;
      });
  },
  methods: {
    getUserAnswer(answers, userAnswer) {
      const index = _findIndex(answers, { id: userAnswer });

      return index !== -1 ? _upperCase(answers[index].answer) : "-";
    },
  },
};
</script>
